var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 792 316.8",
    viewBox: "0 0 792 316.8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1592b"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3729,
    x2: 305.3518,
    xlinkHref: "#a",
    y1: 206.4731,
    y2: 206.4731
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3729,
    x2: 305.3524,
    xlinkHref: "#a",
    y1: 193.342,
    y2: 193.342
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 33.371,
    x2: 305.352,
    xlinkHref: "#a",
    y1: 208.7563,
    y2: 208.7563
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3729,
    x2: 305.3523,
    xlinkHref: "#a",
    y1: 116.1721,
    y2: 116.1721
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3727,
    x2: 305.3521,
    xlinkHref: "#a",
    y1: 159.8651,
    y2: 159.8651
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3729,
    x2: 305.3518,
    xlinkHref: "#a",
    y1: 235.4825,
    y2: 235.4825
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3725,
    x2: 305.3518,
    xlinkHref: "#a",
    y1: 195.137,
    y2: 195.137
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3732,
    x2: 305.352,
    xlinkHref: "#a",
    y1: 181.854,
    y2: 181.854
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3731,
    x2: 305.3519,
    xlinkHref: "#a",
    y1: 62.915,
    y2: 62.915
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 33.373,
    x2: 305.0002,
    xlinkHref: "#a",
    y1: 156.5391,
    y2: 156.5391
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 33.373,
    x2: 305.3524,
    xlinkHref: "#a",
    y1: 144.3366,
    y2: 144.3366
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3725,
    x2: 305.3521,
    xlinkHref: "#a",
    y1: 90.7235,
    y2: 90.7235
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3745,
    x2: 305.3493,
    xlinkHref: "#a",
    y1: 290.2305,
    y2: 290.2305
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3733,
    x2: 305.3419,
    xlinkHref: "#a",
    y1: 211.2392,
    y2: 211.2392
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3727,
    x2: 305.3513,
    xlinkHref: "#a",
    y1: 56.5593,
    y2: 56.5593
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3742,
    x2: 305.3511,
    xlinkHref: "#a",
    y1: 24.0812,
    y2: 24.0812
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3731,
    x2: 305.3505,
    xlinkHref: "#a",
    y1: 76.1534,
    y2: 76.1534
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3729,
    x2: 305.3495,
    xlinkHref: "#a",
    y1: 127.0677,
    y2: 127.0677
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3725,
    x2: 305.3514,
    xlinkHref: "#a",
    y1: 114.2664,
    y2: 114.2664
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3729,
    x2: 305.3518,
    xlinkHref: "#a",
    y1: 38.2105,
    y2: 38.2105
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    gradientUnits: "userSpaceOnUse",
    x1: 33.373,
    x2: 305.3517,
    xlinkHref: "#a",
    y1: 58.1431,
    y2: 58.1431
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3732,
    x2: 305.3523,
    xlinkHref: "#a",
    y1: 281.883,
    y2: 281.883
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    gradientUnits: "userSpaceOnUse",
    x1: 33.373,
    x2: 305.3521,
    xlinkHref: "#a",
    y1: 98.799,
    y2: 98.799
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3729,
    x2: 305.353,
    xlinkHref: "#a",
    y1: 184.2334,
    y2: 184.2334
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3726,
    x2: 305.3519,
    xlinkHref: "#a",
    y1: 238.103,
    y2: 238.103
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3729,
    x2: 305.3523,
    xlinkHref: "#a",
    y1: 269.4443,
    y2: 269.4443
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse",
    x1: 33.373,
    x2: 305.3517,
    xlinkHref: "#a",
    y1: 237.5462,
    y2: 237.5462
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3731,
    x2: 305.3519,
    xlinkHref: "#a",
    y1: 37.237,
    y2: 37.237
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3729,
    x2: 305.3522,
    xlinkHref: "#a",
    y1: 152.3265,
    y2: 152.3265
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientUnits: "userSpaceOnUse",
    x1: 31.5613,
    x2: 307.477,
    xlinkHref: "#a",
    y1: 158.3997,
    y2: 158.3997
  })), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/",
    width: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 169.5,
    cy: 158.4,
    fill: "#fff",
    r: 136
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.1 200.4c-.2-.6-.4-1.2-.4-1.9-27-5.1-53.6-13-79.5-23.7-1.2 1.9-3.2 3.2-5.5 3.5-1.8 20.8.2 40.4 3.8 57.3 1.7.2 3.1 1.1 3.9 2.5 5.8-2.1 11.8-4.5 17.9-7 18-7.5 38.5-17.6 59.8-30.7z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112 178.2c-3.3-.8-5.7-3.8-5.7-7.3 0-.7.1-1.3.3-2-.6-.3-1.2-.5-1.8-.8-13.2-6.1-25-12.3-35.4-18.3-1.6 1.7-3.8 2.8-6.3 2.8-.5 0-1.1-.1-1.6-.1-3.2 7.7-6.1 15.9-8.6 24.6 1.3.9 2.1 2.4 2.1 4.1 0 .8-.2 1.5-.5 2.1 7.7 9.3 16.8 19 27.4 28.6 9.3 8.5 20.3 17.1 32.8 25.2.3-.3.7-.6 1.1-.8-3.6-17.2-5.6-37-3.8-58.1z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239 205.5c1.3 2.6 2.5 5.3 3.7 7.9h.2c.3 0 .5 0 .8.1.9-2 1.7-4.1 2.5-6.1-1.1-.7-1.8-1.9-2.1-3.2-1.4-.1-2.7-.2-4.1-.3-.1.7-.5 1.2-1 1.6z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.8 166.4c1.4-1.8 3.6-3 6-3h.1c.6-3.4 1.3-6.8 2.1-10.2 5.3-21.8 14.8-42.2 28.5-61-2-1.9-3.2-4.6-3.2-7.6 0-2.4.8-4.5 2.1-6.3-4.6-4.3-9.1-8.3-13.3-11.9-.8.6-1.9 1-3 1-1.3 0-2.6-.5-3.5-1.4-19.2 16.6-39.7 39.8-55.3 71.3 2 1.6 3.3 4 3.3 6.7 0 1.2-.2 2.3-.7 3.4 10.3 6 22 12.2 35.1 18.2.6.2 1.3.5 1.8.8z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.5 152.5c.7 1.2 1.2 2.5 1.2 4 0 3.8-2.9 7-6.6 7.4-2.4 12.3-5.6 24.2-9.6 35.6.8.7 1.3 1.5 1.6 2.6 14.2.7 29 .7 44.2-.3-.3 1-.7 1.9-1 2.9 5.2-14.4 8.1-30 8.1-46.2 0-15.1-2.5-29.7-7-43.3.4 1.1.7 2.1 1 3.2-9.9 11.9-20.5 23.3-31.9 34.1z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.9 218.5c0-1.7.8-3.2 2.1-4.1-1.2-2.5-2.3-5-3.5-7.5-.3.1-.7.1-1.1.1-2.5 0-4.5-1.7-5-4-6.3-.7-12.5-1.5-18.8-2.5-.9 2.3-3.1 3.9-5.7 3.9-1.6 0-3.1-.6-4.2-1.6-19 11.7-39.2 22.1-60.4 30.9-6.2 2.6-12.3 5-18.2 7.2 0 .4-.1.8-.2 1.2 23.5 13.8 51.9 24.9 85.3 28.4 13.3-15.6 23.5-31.8 31.4-48.1-1-.9-1.7-2.3-1.7-3.9z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.4 192.2c-2 0-3.9-.8-5.3-2.1-3.1 2.1-6.2 4.2-9.3 6.3.1.4.2.8.2 1.2 6.1 1 12.3 1.8 18.6 2.5.3-.8.8-1.5 1.4-2-1.1-2.1-2.2-4.3-3.3-6.3-.6.3-1.4.4-2.3.4z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.7 162.3c-7.5 6.6-15.2 12.9-23.3 19 .4 1 .7 2.1.7 3.2 0 2.4-1.1 4.5-2.7 5.9 1.1 2.2 2.3 4.4 3.4 6.6.2 0 .4-.1.6-.1 2.5 0 4.6 1.8 5 4.2 1.4.1 2.7.2 4.1.3.8-1.9 2.6-3.2 4.7-3.2.2 0 .4 0 .5.1 4.2-11.8 7.3-23.5 9.5-34.7-.9-.3-1.7-.7-2.5-1.3z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.6 57.9c-1.3 0-2.4-.5-3.3-1.3-1.3 1-2.6 2-3.8 3 .5.8.8 1.7.8 2.7 0 .7-.1 1.3-.4 1.9 4.3 3.7 8.9 7.7 13.6 12.1 1.8-1.5 4.1-2.3 6.6-2.3 2.2 0 4.3.7 6 1.8 8.2-9 17.4-17.7 27.6-25.9 0-.1-.1-.1-.1-.2-14.8.2-28.9 1.5-41.9 3.6-.2 2.5-2.4 4.6-5.1 4.6z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.4 158.4c0-1.2 0-2.5.1-3.7-.1 1.2-.1 2.5-.1 3.7z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.7 184.5c0-2.4 1.1-4.6 2.9-6-21-37.1-43.8-65.2-63.1-85.4-1.8 1.3-4 2.1-6.4 2.1-1.9 0-3.7-.5-5.2-1.4-13.5 18.5-22.9 38.6-28.1 60-.8 3.4-1.5 6.7-2.1 10 2.8 1.1 4.7 3.8 4.7 7 0 .4 0 .9-.1 1.3 22.1 9 48.7 17.7 79 23.4 1-2.1 3.1-3.6 5.6-3.6 1.7 0 3.3.7 4.4 1.9 3-2 6-4 9.1-6.1-.5-.9-.7-2-.7-3.2z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.2 46.7c22 .5 43.5 3.8 64.1 9.7 1.6 1.4 3.2 2.9 4.7 4.4-.4-.1-.8-.2-1.1-.4 2.8 17.5 5 39.8 3.8 64.5-.4 8.4-1.2 16.7-2.3 24.9.4.2.8.4 1.1.6 11.3-10.7 22.3-22.4 32.8-35.3-13-38.8-43-69.7-81.1-84-7.8 4.8-15.2 9.9-22.2 15.1.1.1.2.3.2.5z",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.7 290.7c-1.2-.3-2.4-.6-3.6-.9 1.2.3 2.4.6 3.6.9z",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.1 213.7c-.7-1.6-1.4-3.3-2.1-5 .7 1.7 1.4 3.4 2.1 5z",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.5 55.1c-2.8.5-5.4 1.1-8.1 1.7 0 .4-.1.7-.2 1.1.1 0 .1.1.2.1.8-.5 1.7-.8 2.7-.8.8 0 1.5.2 2.1.5.1 0 .1-.1.2-.1 1.1-.9 2.1-1.7 3.1-2.5z",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.3 23.9c.9.1 1.7.3 2.6.4-.8-.2-1.7-.3-2.6-.4z",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.3 78.5c1.1-1.6 2.3-3.1 3.5-4.6-1.1 1.5-2.3 3-3.5 4.6z",
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.7 128.6c.2-1 .5-2 .7-3-.3 1-.5 2-.7 3z",
    fill: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.1 77.6c1.6 1.9 2.6 4.3 2.6 6.9 0 2.5-.8 4.7-2.2 6.5 23.6 24.6 44.6 52.7 62.3 83.4.5.8 1 1.7 1.4 2.6.7-.2 1.5-.3 2.2-.3 2.1 0 3.9.8 5.3 2.1 7.7-5.8 15.5-12.1 23.1-18.8-.6-1.1-1-2.3-1-3.6 0-4.1 3.3-7.4 7.4-7.4h.3c1.2-8.5 1.9-16.7 2.2-24.3 1.2-25.1-1.1-47.7-4-65.2-22.4-6.5-44.3-9.4-65-9.9-.8 1.8-2.6 3.1-4.7 3.1-1 0-1.9-.3-2.7-.8-10 8.2-19.1 16.8-27.2 25.7z",
    fill: "url(#t)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.7 52c.8-.5 1.8-.8 2.8-.8 2 0 3.7 1.2 4.6 2.9 3.2-.7 6.4-1.4 9.6-2 .4-2.4 2.5-4.3 5-4.3 1.1 0 2 .3 2.8.9 16.8-11.7 32.8-19.8 45.1-25.1.6.1 1.2.2 1.8.2-6.2-.9-12.5-1.3-19-1.3-26.1 0-50.4 7.3-71.1 20 .9-.5 1.8-1.1 2.7-1.6 4.5 2.9 9.8 6.6 15.7 11.1z",
    fill: "url(#u)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.4 56.3c0-.8.2-1.5.5-2.2-6.3-4.8-11.9-8.6-16.6-11.7-13.6 8.3-25.5 19-35.4 31.4 12.9-5.6 29-11.6 47.3-16.5 1.4-.3 2.8-.7 4.2-1z",
    fill: "url(#v)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.2 274.5c-7 0-13.9-.3-20.7-1-5.8 6.7-12 13.1-18.6 19.2 20-3.2 38.6-10.7 54.7-21.6-1.6 1.1-3.2 2.1-4.9 3.1-3.5.2-7 .3-10.5.3z",
    fill: "url(#w)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.1 135.5c.9 0 1.8.2 2.6.4 1.8-3.7 3.8-7.4 5.8-11 13.1-23.1 30.1-43.8 50.7-61.4-.1-.4-.2-.8-.2-1.2 0-.7.2-1.4.4-2-.8.6-1.9 1-3 1-1.8 0-3.3-.9-4.3-2.3-1.4.4-2.8.7-4.2 1.1-20.5 5.5-38.1 12.3-51.7 18.4-10.1 13.9-17.7 29.9-22 47.1 5.2 3.8 11.6 8.2 19.2 13 1.7-1.9 4.1-3.1 6.7-3.1z",
    fill: "url(#x)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.9 181c0-1.4.6-2.6 1.4-3.5-5-6.4-9.4-12.4-13-17.8.2 17.3 3.6 33.8 9.6 49 1.3-7.9 2.8-15.6 4.7-23.2-1.5-.8-2.7-2.5-2.7-4.5z",
    fill: "url(#y)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254 204.9c-.7 2-2.6 3.5-4.8 3.5h-.1c-.9 2.2-1.8 4.3-2.7 6.5 1 .9 1.6 2.2 1.6 3.7 0 1.4-.6 2.6-1.5 3.6 5.2 12 10 24.3 14.3 36.9-.8.7-1.5 1.4-2.3 2.1-4.5-13.2-9.4-25.7-14.5-37.5-.4.1-.7.1-1.1.1-.2 0-.4 0-.6-.1-8.2 16.9-18.4 32.7-30.6 47.2 10.8 1 22 1.1 33.8.3 23.6-16 41.9-39.2 51.8-66.5-8.1.5-16.2.8-24.3.8-6.3-.1-12.7-.3-19-.6z",
    fill: "url(#z)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206 273.1c-16.8-1.9-33.2-5.8-49.1-11.7-12.1-4.5-24-10.2-35.4-16.9-.2.2-.4.3-.6.5 1.5 5.9 3.2 11.5 4.9 16.5 3.9 11.6 8.3 21.6 12 29.2 10.2 2.4 20.7 3.7 31.6 3.7 7.3 0 14.5-.6 21.5-1.7-1.7.3-3.3.5-5 .7 7.3-6.6 14-13.4 20.1-20.3z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.1 245.7c-1.5 0-2.8-.7-3.7-1.7-15.1 5.2-28.7 9.1-39.9 11.8-.8-.8-1.6-1.5-2.3-2.3 11.4-2.7 25.3-6.6 41-12 0-.3-.1-.5-.1-.8 0-.4.1-.8.2-1.2-11.5-7.4-22.6-16-33.3-25.6-10.5-9.5-19.5-19.2-27.3-28.5-.6.4-1.4.7-2.2.7-2.2 8.8-4 18-5.4 27.7 16.5 37.1 49.2 65.4 89 76-3.6-7.5-7.5-16.7-11.1-27.4-1.7-5.1-3.4-10.7-4.9-16.7z",
    fill: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.2 46.7c.5-2.3 2.5-4.1 5-4.1 1.2 0 2.3.5 3.2 1.2 6.4-4.8 13.2-9.5 20.4-14 1.1.4 2.3.8 3.4 1.2-8.1-3-16.5-5.3-25.3-6.8-12.3 5-29.6 13.2-47.9 25.9 14-2.1 27.7-3.2 41.2-3.4z",
    fill: "url(#C)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 176h.2c2.4-8.5 5.3-16.7 8.6-24.6-2.5-1.5-4.2-4.2-4.2-7.3 0-1 .2-2 .5-2.9-7.2-4.6-13.4-8.8-18.5-12.5-1.9 8.4-3 17.2-3.2 26.1 4.1 6.2 9.2 13.5 15.4 21.4.4-.2.8-.2 1.2-.2z",
    fill: "url(#D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.5 296.4c-36.8 0-71.5-14.4-97.5-40.4-26.1-26.1-40.4-60.7-40.4-97.6 0-36.8 14.4-71.5 40.4-97.6s60.7-40.4 97.6-40.4 71.5 14.4 97.6 40.4c26.1 26.1 40.4 60.7 40.4 97.6 0 36.8-14.4 71.5-40.4 97.6-26.2 26-60.8 40.4-97.7 40.4zm0-273.4c-74.6 0-135.4 60.7-135.4 135.4s60.7 135.4 135.4 135.4 135.4-60.7 135.4-135.4-60.7-135.4-135.4-135.4z",
    fill: "url(#E)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1e191b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m354 193.8h3.7v32.7h-3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.6 193.8h12.2c7.4 0 12.2 3.9 12.2 10.4v.1c0 7.1-5.9 10.7-12.9 10.7h-7.9v11.5h-3.7v-32.7zm11.8 17.8c5.4 0 9-2.9 9-7.2v-.1c0-4.7-3.5-7.1-8.8-7.1h-8.3v14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.9 221.9c-3 3.2-6.5 5.1-10.7 5.1-5.9 0-10.3-3.7-10.3-9.2v-.1c0-4.3 2.9-7.5 7.9-9.4-2.2-2.6-3.3-4.6-3.3-7.2v-.1c0-4.3 3.5-7.8 8.6-7.8 4.6 0 7.9 3.3 7.9 7.4v.1c0 4.2-2.9 6.8-7.7 8.5l7.5 7.6c1.4-2.1 2.8-4.6 3.9-7.3l3 1.4c-1.4 3.1-2.9 5.9-4.7 8.2l5.7 5.8-2.8 2.2zm-2.2-2.3-8.7-9c-4.3 1.6-6.3 4.3-6.3 7v.1c0 3.5 2.8 6.2 6.8 6.2 3.1 0 5.8-1.6 8.2-4.3zm-1-18.7c0-2.7-2-4.6-4.6-4.6-2.9 0-5 2.1-5 4.7v.1c0 1.9.8 3.4 3.3 6 4.1-1.3 6.3-3.4 6.3-6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m499.3 197.2h-11v-3.4h25.7v3.4h-11v29.3h-3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.2 193.8h23.7v3.4h-20v11.2h17.9v3.4h-17.9v11.5h20.2v3.4h-23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m564.9 193.8h3.7v29.3h18.4v3.4h-22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.1 193.8h23.7v3.4h-20v11.2h17.9v3.4h-17.9v11.5h20.2v3.4h-23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m636.3 210.3c0-9.4 6.9-17 16.5-17 5.9 0 9.5 2.1 12.8 5.2l-2.5 2.7c-2.8-2.6-5.8-4.5-10.3-4.5-7.2 0-12.7 5.9-12.7 13.4v.1c0 7.6 5.5 13.5 12.7 13.5 4.5 0 7.4-1.7 10.6-4.7l2.4 2.4c-3.4 3.5-7.2 5.8-13.1 5.8-9.4-.1-16.4-7.5-16.4-16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m676.2 210.3c0-9.1 6.8-17 16.7-17 10 0 16.6 7.8 16.6 16.8v.1c0 9-6.8 16.9-16.7 16.9s-16.6-7.8-16.6-16.8zm29.5 0c0-7.5-5.4-13.6-12.9-13.6s-12.8 6-12.8 13.4v.1c0 7.4 5.4 13.5 12.9 13.5s12.8-6 12.8-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m723.7 193.8h3.7l11.9 17.9 11.9-17.9h3.7v32.7h-3.7v-26.5l-11.9 17.5h-.2l-11.9-17.5v26.5h-3.6v-32.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m351.4 106h6.9l41.2 52.5v-52.5h7.2v65.5h-5.9l-42.3-53.7v53.7h-7.2v-65.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443 166.3c6.6 0 11.3-2.7 15.2-6.8l4.5 4c-4.9 5.4-10.8 9.1-19.9 9.1-13.3 0-24.1-10.2-24.1-25.2 0-14 9.8-25.2 23.2-25.2 14.3 0 22.5 11.4 22.5 25.6 0 .7 0 1.4-.1 2.5h-38.3c1 10.1 8.5 16 17 16zm14.1-21.9c-.8-8.8-5.9-16.3-15.4-16.3-8.3 0-14.7 6.9-15.7 16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m477.2 158.7v-29.2h-6.7v-6.4h6.7v-14.6h7.2v14.6h15.3v6.4h-15.3v28.2c0 5.9 3.3 8 8.1 8 2.4 0 4.5-.5 7-1.7v6.2c-2.5 1.3-5.2 2.1-8.7 2.1-7.7 0-13.6-3.8-13.6-13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m507 161.9 4.6-5.4c6.8 6.2 13.4 9.3 22.4 9.3 8.8 0 14.6-4.7 14.6-11.1v-.2c0-6.1-3.3-9.5-17-12.4-15.1-3.3-22-8.1-22-18.9v-.2c0-10.3 9.1-17.9 21.5-17.9 9.5 0 16.4 2.7 23 8l-4.3 5.7c-6.1-5-12.2-7.1-18.9-7.1-8.5 0-13.9 4.7-13.9 10.6v.2c0 6.2 3.4 9.6 17.8 12.7 14.6 3.2 21.3 8.5 21.3 18.5v.2c0 11.2-9.4 18.5-22.3 18.5-10.4 0-18.9-3.5-26.8-10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m567.6 123.1h7.2v9.7c3.9-5.8 9.6-10.8 18.5-10.8 11.6 0 23.1 9.2 23.1 25.1v.2c0 15.8-11.4 25.2-23.1 25.2-9 0-14.8-4.9-18.5-10.3v24.2h-7.2zm41.5 24.3v-.2c0-11.4-7.9-18.7-17-18.7-9 0-17.5 7.6-17.5 18.6v.2c0 11.2 8.5 18.7 17.5 18.7 9.3 0 17-6.9 17-18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m623.7 157.4v-.2c0-10.4 8.4-15.8 20.7-15.8 6.2 0 10.5.8 14.8 2.1v-1.5c0-8.6-5.2-13.1-14.3-13.1-5.7 0-10.2 1.4-14.7 3.5l-2.2-5.9c5.3-2.4 10.5-4.1 17.6-4.1 6.8 0 12.2 1.9 15.6 5.3s5 8 5 14.2v29.5h-7.1v-7.2c-3.4 4.3-8.9 8.2-17.4 8.2-9 .1-18-5-18-15zm35.6-3.7v-4.5c-3.6-1-8.2-2.1-14.1-2.1-9 0-14.1 3.9-14.1 9.7v.2c0 6.1 5.6 9.6 12.2 9.6 8.8.1 16-5.2 16-12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m679.2 123.1h7.2v12.6c3.6-8 10.6-13.8 19.7-13.5v7.8h-.6c-10.6 0-19.2 7.6-19.2 22.2v19.3h-7.2v-48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m714.7 103.2h7.2v47.1l26.1-27.2h9l-20.3 20.8 20.9 27.6h-8.6l-17.3-22.5-9.8 9.9v12.6h-7.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.05eeba2627b6b6d8ddfbbd78d9f1942f.svg";
export { ForwardRef as ReactComponent };